import InfoIcon from '../infoIcon';
import useTranslation from '../../../hooks/useTranslation';

function Background({ children, isAwardPopup, isWinWithBet }) {
  const t = useTranslation();
  return (
    <div className='cpt-container-pp'>
      <style>{`:root{--scroll: hidden}`}</style>
      <div className='cpt-freebet-popup-wrapper'>
        <div className='cpt-freebet-popup-container'>
          <div className='cpt-freebet-popup-gift-img' />
          {isAwardPopup && (
            <InfoIcon itle text={t(isWinWithBet ? 'FREE_BET_AMOUNT' : 'FREE_BET_WIN_AMOUNT')} />
          )}
          {children}
        </div>
      </div>
    </div>
  );
}

export default Background;
